module.exports = __webpack_public_path__ + "static/media/startup.e11d1e78.mp4";